import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MeetingNotesService } from 'src/app/services/meetingNotes/meeting-notes.service';
import { NotesEnum } from 'src/app/services/notes/NotesEnum';
import { NotesDialogComponent } from '../notes/notes-dialog/notes-dialog.component';
import { NotesRefreshService } from 'src/app/services/notes/notesrefresh.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-meeting-notes',
  templateUrl: './user-meeting-notes.component.html',
  styleUrls: ['./user-meeting-notes.component.scss'],
})
export class UserMeetingNotesComponent implements OnInit {
  @Input() userId: string;
  isLoading: boolean = true;
  allCmMeetingNotesList = [];
  allPntMeetingNotesList = [];
  allCapLeadMeetingNotesList = [];
  selectedYear: number;
  years: number[] = [];
  subscription: Subscription;

  constructor(
    public meetingNotesService: MeetingNotesService,
    public dialog: MatDialog,
    public notesRefreshService: NotesRefreshService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.selectedYear = new Date().getFullYear();
    for (let year = this.selectedYear; year >= 2022; year--) {
      this.years.push(year);
    }
    this.getAllMeetingNote();
    this.subscription = this.notesRefreshService.refresh$.subscribe(() => {
      this.getAllMeetingNote();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedYear'] && !changes['selectedYear'].isFirstChange()) {
      this.getAllMeetingNote();
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  changeYear(event) {
    this.getAllMeetingNote();
  }

  getAllMeetingNote() {
    // Clear all previous lists immediately
    this.allCmMeetingNotesList = [];
    this.allPntMeetingNotesList = [];
    this.allCapLeadMeetingNotesList = [];
    this.meetingNotesService
      .getAllMeetingNotesForUserByYear(this.selectedYear)
      .subscribe({
        next: (res) => {
          const allNotes = res.body || [];

          const filteredNotes = allNotes.filter(
            (note) => String(note.year) === String(this.selectedYear)
          );

          this.allCmMeetingNotesList = filteredNotes.filter(
            (note) => note.noteType === NotesEnum.Career_Manager
          );

          this.allPntMeetingNotesList = filteredNotes.filter(
            (note) => note.noteType === NotesEnum.PnT_Buddy
          );

          this.allCapLeadMeetingNotesList = filteredNotes.filter(
            (note) => note.noteType === NotesEnum.Capability_Lead
          );
          this.isLoading = false;
        },
        error: (err) => {
          console.log('Error in getting all meeting notes :', err);
          this.isLoading = false;
        },
      });
  }

  openAssignNotesDialogue(action: string, noteData?: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '50%';
    dialogConfig.height = '68%';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      directReporteeId: this.userId,
      selectedYear: this.selectedYear,
      noteData: noteData,
      action: action,
      isUserView: true,
    };

    const dialogRef = this.dialog
      .open(NotesDialogComponent, dialogConfig)
      .afterClosed()
      .subscribe((result) => {
        if (result.event == 'Closed') {
        } else {
          // Refresh notes after add/edit
        }
      });
  }
}
